/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/no-unused-prop-types */
import React from 'react'
import CurrencyInput from 'react-currency-input-field'

import { Text } from 'components'
import classNames from 'classnames'
import noop from 'lib/noop'
import styles from './CurrencyInput.module.scss'

const _CurrencyInput = ({
  id = 0,
  name,
  value = '',
  onChange = noop,
  className = '',
  label = '',
  labelTextColor = '',
  description = '',
  labelClassName = '',
  hasError = false,
  errorMessage = 'error',
  ...base
}) => {
  const classesInput = classNames(className, styles.wrapper, {
    [styles.error]: hasError,
  })
  return (
    <div className={classesInput}>
      {label && (
        <label
          htmlFor={id}
          className={classNames(styles.label, labelClassName)}
        >
          <Text fontSize="medium" color={labelTextColor || null}>
            {label}
          </Text>
          {description && (
            <Text fontSize="small" color="lightBlueColor">
              {description}
            </Text>
          )}
        </label>
      )}
      <CurrencyInput
        id={id}
        name={name}
        intlConfig={{ locale: 'pt-BR', currency: 'BRL' }}
        className={classNames(styles.input, className, {
          [styles.disabled]: base?.readOnly || base?.disabled,
        })}
        value={value}
        decimalsLimit={2}
        placeholder="R$ "
        prefix="R$ "
        onValueChange={e => {
          onChange(id, e)
        }}
        {...base}
      />
      {hasError && <span className={styles.span}>{errorMessage}</span>}
    </div>
  )
}

export default React.memo(_CurrencyInput)
